// eslint-disable-next-line no-undef
export const form = {
  all_timezone_list: "/api/v2/i18n/perf/tool/timezone/",
  register: "/api/v1/self-serve/adv-account/register/",
  self_promotion: "/api/v2/i18n/advertiser/self/promotion/",
  article: TIKTOK_AD_DOMAIN + "/i18n_node/cognition/knowledge/detail/",
  cdnUrl: "https://sf16-cgfe-sg.ibytedtos.com/obj/cognition-sg-public",
  phone_shark: "/api/v3/i18n/shark/event/",
  ...generateApi({
    lead_forms: "/form/leadForms"
  }),
  adv_industry_list:
    "/api/v3/i18n/account/industry/self_service_simplified_list/",
  check_referral_code: "/growth/channel/referral/check_referral_code"
};

export const adminCenter = generateApi({
  openBatchCreateNomination: "/admin-center/openBatchCreateNomination",
})

export const email = {
  ...generateApi({
    validate_leadid: "/email/validateLeadId",
    subscribe_config: "/email/querySubscribeConf",
    update_subscribe_config: "/email/updateSubscribeConf"
  }),
  behavior_report: "/touch/behavior_report/" // http: get
};

export const lead = generateApi({
  create_lead: "/lead/createLead"
});

export const config = generateApi({
  lead_form_config: "/config/leadForm",
  common_config: "/config/common",
  shopify_black: "/config/shopifyBlack",
  get_ip_info: "/config/getIpInfo",
  getDynamicLpInfo: "/config/getDynamicLpInfo",
});

export const feelgoodAuth = generateApi({
  getToken: "/feelgoodAuth/getToken",
});

// eslint-disable-next-line no-undef
const ssoDomain = SSO_DOMAIN;

export const index = {
  login_info: "/api/v1/self-serve/adv-account/user-info/",
  adv_list: "/api/v2/i18n/account/account_switch_list/", // with timestamp info
  account_info: "/passport/web/account/info/",
  set_cookie: "/passport/sso/login/callback/",
  send_code: "/passport/web/send_code",
  bind_phone: "/passport/web/mobile/bind/",
  verify_code: "/passport/web/mobile/check_code/",
  log_out: `${ssoDomain}/logout/`,
  notice: '/ac/api/user/notification',
  cash_active_status: '/tt4b/bff_node/agw_bff/getAdvCashActiveStatus',
  newbie_eligibility: TIKTOK_AD_DOMAIN + "/nb/v1/eligibility"
};

function generateApi(obj) {
  // eslint-disable-next-line no-undef
  const prefix = (SITE_PATH || "/") + "api";
  Object.keys(obj).forEach(key => {
    obj[key] = prefix + obj[key];
  });
  return obj;
}

export const abtest = generateApi({
  getABConfigByAdv: "/abtest/getABConfigByAdv",
  getABConfigByFeature: "/abtest/getABConfigByFeature",
});
